export function mapAnnouncement(raw) {
  if (!raw?.Announcement) return null;
  return {
    text: raw?.Announcement,
    // subtitle: raw.titleSection.subtitle,
  };
}

export function mapCarouselSlides(raw) {
  if (!raw?.carousel) return [];
  return [...raw.carousel]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((c) => ({
      id: c.title,
      image: c.image,
      link: c.link,
    }));
}

export function mapFeatureList(raw) {
  if (!raw?.featureCards) return [];
  return raw.featureCards.map((f) => ({
    id: f.name,
    name: f.name,
    svg: f.svg,
  }));
}

export function mapCards(raw) {
  if (!raw?.cards) return [];
  return raw.cards.map((c, i) => ({
    id: c.title || `card-${i}`,
    title: c.title,
    description: c.description,
    image: c.image,
    link: c.link,
  }));
}

export function mapCarouselList(raw) {
  if (!raw?.carousel) return [];
  return [...raw.carousel]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((c, i) => ({
      id: c.title || `carousel-${i}`,
      title: c.title,
      description: c.description,
      image: c.image,
      link: c.link,
    }));
}

export function mapYoutube(raw) {
  return raw?.phoneSection?.youtube ?? null;
}

export function mapInstagram(raw) {
  return raw?.phoneSection?.instagram ?? null;
}

export function mapSolutions(raw) {
  if (!raw?.solutions) return [];
  return raw.solutions.map((s, i) => ({
    id: s.title || `solution-${i}`,
    title: s.title,
    description: s.description,
    ImageUrl: s.ImageUrl,
    link: s.link,
  }));
}

export const mapListings = (content) => {
  if (!content?.listings || !Array.isArray(content.listings)) return [];
  return content.listings; // already in {id, type, title, role, location, description, image, validTill} shape
};
